var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"two-columns-layout"},[_c('div',{staticClass:"two-columns-layout__main"},[_vm._t("default")],2),(_vm.hasRightSlot)?_c('div',{class:['two-columns-layout__aux', _vm.auxClass]},[_vm._t("right")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }